<template>
    <div class="main">
        <c-panel title="INTEGRAÇÃO — GOOGLE CLASSROOM" titleIcon="fab fa-google">

            <el-tabs v-model="aba">
                <!-- ==================== CONFIGURAÇÃO ==================== -->
                <el-tab-pane label="CONFIGURAÇÃO" name="config">
                    <el-form ref="dados" :model="dados" label-position="top" @submit.native.prevent="salvar">

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12">
                                <el-form-item label="Client ID" prop="client_id" :rules="$requiredBlur">
                                    <el-input v-model="dados.client_id" placeholder="123456.apps.googleusercontent.com"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item label="Client Secret">
                                    <el-input v-model="dados.client_secret" type="password" show-password
                                        :placeholder="temSecret ? 'Preenchido — deixe em branco para manter' : 'Obrigatório na primeira configuração'"></el-input>
                                    <small>Gravado criptografado. Nenhum endpoint devolve este valor.</small>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12">
                                <el-form-item label="Domínio do Workspace" prop="domain" :rules="$requiredBlur">
                                    <el-input v-model="dados.domain" placeholder="municipio.sc.gov.br"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item label="E-mail do administrador" prop="admin_email" :rules="[$requiredBlur, $emailBlur]">
                                    <el-input v-model="dados.admin_email" placeholder="admin@municipio.sc.gov.br"></el-input>
                                    <small>Conta usada na domain-wide delegation.</small>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-form-item label="Service account (JSON)">
                            <el-input v-model="dados.service_account_json" type="textarea" :rows="4"
                                :placeholder="temServiceAccount ? 'Preenchido — deixe em branco para manter' : 'Cole aqui o JSON da conta de serviço'"></el-input>
                            <small>Também gravado criptografado.</small>
                        </el-form-item>

                        <el-form-item label="Tipos de ensino a sincronizar" prop="tipos_ensino" :rules="$requiredChange">
                            <el-checkbox-group v-model="dados.tipos_ensino">
                                <el-checkbox v-for="t in tiposDisponiveis" :key="t" :label="t">{{ rotuloTipo(t) }}</el-checkbox>
                            </el-checkbox-group>
                            <div><small class="u-text-muted">O edital exige cobertura de todos os tipos de ensino da rede.</small></div>
                        </el-form-item>

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="8">
                                <el-form-item label="Sincronizar turmas">
                                    <el-switch v-model="dados.sincroniza_turmas"></el-switch>
                                    <div><small class="u-text-muted">Cria/atualiza os cursos no Classroom.</small></div>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="8">
                                <el-form-item label="Sincronizar alunos">
                                    <el-switch v-model="dados.sincroniza_alunos"></el-switch>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="8">
                                <el-form-item label="Sincronizar professores">
                                    <el-switch v-model="dados.sincroniza_professores"></el-switch>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-form-item label="Integração ativa">
                            <el-switch v-model="dados.situacao" active-text="Ativa" inactive-text="Desativada"></el-switch>
                            <div><small class="u-text-muted">Nasce desativada: integração externa não se auto-habilita.</small></div>
                        </el-form-item>

                        <div class="u-text-right u-mt-20">
                            <el-button v-if="podeConfigurar" icon="el-icon-connection" @click="testar">TESTAR CONEXÃO</el-button>
                            <el-button class="u-ml-10" v-if="podeConfigurar" type="primary" native-type="submit">SALVAR</el-button>
                        </div>
                    </el-form>

                    <el-alert v-if="resultadoTeste" class="u-mt-15" :closable="false"
                        :type="resultadoTeste.ok ? 'success' : 'warning'"
                        :title="resultadoTeste.ok ? 'Conexão disponível.' : 'Conexão indisponível.'"
                        :description="resultadoTeste.motivo || ''"></el-alert>

                    <div v-if="cfg && cfg.diagnostico.requisitos_externos" class="u-mt-20">
                        <h4>Requisitos externos</h4>
                        <ul>
                            <li v-for="(r, i) in cfg.diagnostico.requisitos_externos" :key="i">{{ r }}</li>
                        </ul>
                    </div>
                </el-tab-pane>

                <!-- ==================== SINCRONIZAÇÃO ==================== -->
                <el-tab-pane label="SINCRONIZAÇÃO" name="sync">
                    <el-alert type="info" :closable="false" class="u-mb-15"
                        title="A ordem é obrigatória: curso primeiro, depois alunos e professores."
                        description="Turma cujo curso falhou não tenta os demais — isso evita uma cascata de erros que esconderia a causa real."></el-alert>

                    <el-form label-position="top" @submit.native.prevent>
                        <el-row :gutter="10" class="u-mb-15">
                            <el-col :xs="24" :sm="6">
                                <el-form-item label="Período letivo" class="u-mb-0">
                                    <el-select v-model="periodoId" style="width: 100%;">
                                        <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="10">
                                <el-form-item label="Escola (em branco = toda a rede)" class="u-mb-0">
                                    <el-select v-model="instituicaoId" clearable filterable style="width: 100%;">
                                        <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="8" class="u-text-right u-mt-25">
                                <el-button v-if="podeConfigurar" type="primary" size="small" icon="el-icon-refresh"
                                    :disabled="!periodoId" @click="sincronizar">SINCRONIZAR</el-button>
                            </el-col>
                        </el-row>
                    </el-form>

                    <div v-if="resultado">
                        <el-alert v-if="resultado.aviso" type="warning" :closable="false" class="u-mb-15"
                            :title="resultado.aviso"></el-alert>

                        <el-row :gutter="10" class="u-mb-20">
                            <el-col :xs="8" :sm="4"><div class="kpi"><span class="n">{{ resultado.turmas_ok }}</span><span class="r">Turmas OK</span></div></el-col>
                            <el-col :xs="8" :sm="4"><div class="kpi kpi-erro"><span class="n">{{ resultado.turmas_erro }}</span><span class="r">Turmas c/ erro</span></div></el-col>
                            <el-col :xs="8" :sm="4"><div class="kpi"><span class="n">{{ resultado.alunos_ok }}</span><span class="r">Alunos OK</span></div></el-col>
                            <el-col :xs="8" :sm="4"><div class="kpi kpi-erro"><span class="n">{{ resultado.alunos_erro }}</span><span class="r">Alunos c/ erro</span></div></el-col>
                            <el-col :xs="8" :sm="4"><div class="kpi"><span class="n">{{ resultado.professores_ok }}</span><span class="r">Professores OK</span></div></el-col>
                            <el-col :xs="8" :sm="4"><div class="kpi kpi-erro"><span class="n">{{ resultado.professores_erro }}</span><span class="r">Professores c/ erro</span></div></el-col>
                        </el-row>

                        <div v-if="resultado.detalhes && resultado.detalhes.length" class="container-table">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th style="width: 200px;">Entidade</th>
                                        <th style="width: 110px;">Etapa</th>
                                        <th>Erro</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(d, i) in resultado.detalhes" :key="i">
                                        <td>{{ d.turma || d.aluno || d.professor || '—' }}</td>
                                        <td>{{ d.etapa }}</td>
                                        <td><small>{{ d.erro }}</small></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-tab-pane>

                <!-- ==================== LOG POR ENTIDADE ==================== -->
                <el-tab-pane label="LOG DE VÍNCULOS" name="log">
                    <el-row :gutter="10" class="u-mb-15">
                        <el-col :xs="12" :sm="5">
                            <el-select v-model="filtroLog.entidade" clearable size="small" placeholder="Entidade" style="width: 100%;" @change="carregarLog">
                                <el-option value="turma" label="Turma"></el-option>
                                <el-option value="aluno" label="Aluno"></el-option>
                                <el-option value="professor" label="Professor"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="12" :sm="5">
                            <el-select v-model="filtroLog.situacao_sync" clearable size="small" placeholder="Situação" style="width: 100%;" @change="carregarLog">
                                <el-option value="pendente" label="Pendente"></el-option>
                                <el-option value="sincronizado" label="Sincronizado"></el-option>
                                <el-option value="erro" label="Erro"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="14" class="u-text-right">
                            <el-button size="small" icon="el-icon-refresh" @click="carregarLog">ATUALIZAR</el-button>
                        </el-col>
                    </el-row>

                    <el-row v-if="log" :gutter="10" class="u-mb-15">
                        <el-col :xs="8"><div class="kpi"><span class="n">{{ log.resumo.sincronizado }}</span><span class="r">Sincronizados</span></div></el-col>
                        <el-col :xs="8"><div class="kpi"><span class="n">{{ log.resumo.pendente }}</span><span class="r">Pendentes</span></div></el-col>
                        <el-col :xs="8"><div class="kpi kpi-erro"><span class="n">{{ log.resumo.erro }}</span><span class="r">Com erro</span></div></el-col>
                    </el-row>

                    <div v-if="log" class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 110px;">Entidade</th>
                                    <th style="width: 90px;">ID</th>
                                    <th style="width: 130px;">Situação</th>
                                    <th style="width: 160px;">Sincronizado em</th>
                                    <th>Último erro</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="v in log.itens.data" :key="v.id">
                                    <td>{{ v.entidade }}</td>
                                    <td>{{ v.entidade_id }}</td>
                                    <td>
                                        <el-tag size="mini" :type="corSync(v.situacao_sync)">{{ v.situacao_sync }}</el-tag>
                                    </td>
                                    <td>{{ v.sincronizado_em ? dataHora(v.sincronizado_em) : '—' }}</td>
                                    <td><small>{{ v.ultimo_erro || '—' }}</small></td>
                                </tr>
                                <tr v-if="!log.itens.data.length"><td colspan="5" class="u-text-center">Nenhum vínculo registrado.</td></tr>
                            </tbody>
                        </table>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO L — item 2: Google Classroom. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        aba: 'config', cfg: null, temSecret: false, temServiceAccount: false,
        tiposDisponiveis: [], instituicoes: [],
        periodoId: null, instituicaoId: null,
        resultado: null, resultadoTeste: null, log: null,
        filtroLog: { entidade: '', situacao_sync: '' },
        dados: { client_id: '', client_secret: '', domain: '', service_account_json: '',
                 admin_email: '', sincroniza_turmas: true, sincroniza_alunos: true,
                 sincroniza_professores: true, tipos_ensino: [], situacao: false }
    }),
    computed: {
        /** Integração é configuração de infraestrutura — o backend também restringe. */
        podeConfigurar () { return [4, 5].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})

        this.carregarConfig()
        this.carregarLog()
    },
    methods: {
        carregarConfig () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/integracao-classroom/getConfig`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }

                this.cfg = r.data
                this.tiposDisponiveis = r.data.tipos_ensino_disponiveis || []

                if (r.data.configurado && r.data.config) {
                    const c = r.data.config
                    this.dados.client_id = c.client_id
                    this.dados.domain = c.domain
                    this.dados.admin_email = c.admin_email
                    this.dados.sincroniza_turmas = !!c.sincroniza_turmas
                    this.dados.sincroniza_alunos = !!c.sincroniza_alunos
                    this.dados.sincroniza_professores = !!c.sincroniza_professores
                    this.dados.tipos_ensino = c.tipos_ensino || []
                    this.dados.situacao = !!c.situacao
                    this.temSecret = !!c.tem_client_secret
                    this.temServiceAccount = !!c.tem_service_account
                } else {
                    // Sem configuração, oferece todos os tipos marcados (o item 2 pede todos).
                    this.dados.tipos_ensino = this.tiposDisponiveis.slice()
                }
            }).catch(e => this.$store.commit('throwException', e))
        },
        rotuloTipo (t) {
            return { regular: 'Regular', infantil: 'Educação Infantil', fundamental: 'Ensino Fundamental',
                medio: 'Ensino Médio', eja_seriado: 'EJA seriado', eja_modular: 'EJA modular',
                atividade_complementar: 'Atividade complementar', aee: 'AEE' }[t] || t
        },
        corSync (s) { return { sincronizado: 'success', pendente: 'info', erro: 'danger' }[s] || 'info' },
        dataHora (d) {
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]} ${d.substring(11, 16)}`
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/integracao-classroom/salvarConfig`,
                    this.dados, this.$store.getters.getHeaderAuth
                ).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                    // Os segredos não voltam do backend — limpar evita reenviar o mesmo valor.
                    this.dados.client_secret = ''
                    this.dados.service_account_json = ''
                    this.carregarConfig()
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        testar () {
            this.resultadoTeste = null
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/integracao-classroom/testarConexao`,
                {}, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.resultadoTeste = r.data
            }).catch(e => this.$store.commit('throwException', e))
        },
        sincronizar () {
            this.resultado = null
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/integracao-classroom/sincronizarTurmas`,
                { periodo_letivo_id: this.periodoId, instituicao_id: this.instituicaoId },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.resultado = r.data
                this.carregarLog()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        carregarLog () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/integracao-classroom/status`,
                this.filtroLog, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) return
                this.log = r.data
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.kpi { border: 1px solid #dcdfe6; border-radius: 4px; padding: 10px; text-align: center; margin-bottom: 8px; }
.kpi .n { display: block; font-size: 20px; font-weight: bold; }
.kpi .r { display: block; font-size: 11px; color: #606266; }
.kpi-erro { border-left: 4px solid #f56c6c; }
</style>
